"use client";
import { Box, HStack, Stack } from "@chakra-ui/react";
import Image from "next/image";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import Tag from "@/components/tag";
import CheckImg from "public/cloudUnifiedCom/Check_circle.png";
import { scrollToElement } from "@/utils/scrollToElement";
import { Heading, Text, Button } from "@/elements";
import { PRICING_CONSTANTS } from "./constants";

const PricingComponent = () => {
  const { heading, description, plans, btnText } = PRICING_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Box>
      <Stack gap={6} justify={"center"} align="center">
        <Heading as="h2" variant={HeadingVariant}>
          {heading}
        </Heading>
        <Text
          variant={TextVariant}
          color="text.100"
          w={{ xl: "40%" }}
          textAlign={"center"}
        >
          {description}
        </Text>
        <Stack direction={{ base: "column", md: "row" }} gap={6}>
          {plans.map((plan, index) => (
            <Stack
              key={index}
              borderRadius="md"
              p={6}
              boxShadow="lg"
              align="center"
              gap={4}
            >
              <Tag label={plan.frequency} />
              <Box>
                <Heading as="h3" size="xl" mt={4}>
                  {plan.price}
                </Heading>
                <Text fontSize={"sm"} color="gray.600" textAlign={"center"}>
                  per user
                </Text>
              </Box>
              <Stack h="full" justify="space-between">
                <Stack gap={2}>
                  {plan.features.map((feature, featureIndex) => (
                    <HStack key={featureIndex} align="start">
                      <Image
                        alt={"Point"}
                        src={CheckImg}
                        style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                      />{" "}
                      <Text variant={"body3"} color="text.100">
                        {feature}
                      </Text>
                    </HStack>
                  ))}
                </Stack>
                <Button
                  variant={"ideal"}
                  width="full"
                  mt={6}
                  onClick={() => scrollToElement("contact-us", 120)}
                >
                  {btnText}
                </Button>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default PricingComponent;
